import { render, staticRenderFns } from "./genDataSon.vue?vue&type=template&id=25495d33&"
import script from "./genDataSon.vue?vue&type=script&lang=js&"
export * from "./genDataSon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports